export default __webpack_public_path__ + "static/media/sponsor.8cbef69f.png";